/* Sofia Lark mega menu behaviour (desktop).
   - Mouse: opens after a short pause, closes after leaving, so passing over the bar does not flash panels.
   - Touch: the first tap on a top-level link opens its panel, a second tap follows the link.
   - Keyboard: the chevron button toggles the panel, Escape closes it and returns focus,
     moving focus out of the item closes it.
   The top-level labels stay real links, so they can be opened in a new tab. */
(function () {
  'use strict';

  var nav = document.querySelector('[data-sl-nav]');
  if (!nav) return;

  var wrapper = document.getElementById('HeaderWrapper');
  var scrim = document.querySelector('[data-sl-scrim]');
  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-sl-item]'));
  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktop = window.matchMedia('(min-width: 769px)');
  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 200;

  var current = null;
  var openTimer = null;
  var closeTimer = null;
  var hadLightHeader = false;

  function parts(item) {
    return {
      trigger: item.querySelector('[data-sl-trigger]'),
      toggle: item.querySelector('[data-sl-toggle]'),
      panel: item.querySelector('[data-sl-panel]')
    };
  }

  function setHeaderOpen(isOpen) {
    document.documentElement.classList.toggle('sl-nav-active', isOpen);
    if (!wrapper) return;
    if (isOpen) {
      if (!wrapper.classList.contains('sl-nav-open')) {
        hadLightHeader = wrapper.classList.contains('is-light');
        wrapper.classList.remove('is-light');
        wrapper.classList.add('sl-nav-open');
      }
    } else {
      wrapper.classList.remove('sl-nav-open');
      if (hadLightHeader) wrapper.classList.add('is-light');
      hadLightHeader = false;
    }
  }

  function open(item) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (current === item) return;
    if (current) close(current, true);

    var p = parts(item);
    p.panel.hidden = false;
    item.setAttribute('data-open', 'true');
    p.toggle.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.hidden = false;
    setHeaderOpen(true);
    current = item;
  }

  function close(item, switching) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (!item) return;

    var p = parts(item);
    p.panel.hidden = true;
    item.removeAttribute('data-open');
    p.toggle.setAttribute('aria-expanded', 'false');
    if (current === item) current = null;
    if (!switching) {
      if (scrim) scrim.hidden = true;
      setHeaderOpen(false);
    }
  }

  function showPreview(panel, id) {
    var target = id && document.getElementById(id);
    if (!target) return;
    panel.querySelectorAll('[data-sl-preview]').forEach(function (el) {
      el.hidden = el !== target;
    });
    panel.querySelectorAll('[data-sl-preview-target]').forEach(function (link) {
      if (link.getAttribute('data-sl-preview-target') === id) {
        link.setAttribute('data-active', '');
      } else {
        link.removeAttribute('data-active');
      }
    });
  }

  items.forEach(function (item) {
    var p = parts(item);
    if (!p.trigger || !p.toggle || !p.panel) return;

    item.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse' || !desktop.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(item); }, current ? 0 : OPEN_DELAY);
    });

    item.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { close(item); }, CLOSE_DELAY);
    });

    p.trigger.addEventListener('click', function (event) {
      if (hoverCapable.matches) return;
      if (item.getAttribute('data-open') !== 'true') {
        event.preventDefault();
        open(item);
      }
    });

    p.toggle.addEventListener('click', function () {
      if (item.getAttribute('data-open') === 'true') {
        close(item);
      } else {
        open(item);
        var first = p.panel.querySelector('a[href]');
        if (first) first.focus({ preventScroll: true });
      }
    });

    item.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && item.getAttribute('data-open') === 'true') {
        event.preventDefault();
        event.stopPropagation();
        close(item);
        // The theme's own Escape handling blurs the active element; refocus after it runs.
        setTimeout(function () { p.toggle.focus(); }, 0);
      }
    });

    item.addEventListener('focusout', function (event) {
      if (item.getAttribute('data-open') !== 'true') return;
      // Only react when focus actually moved to another element (Tab / Shift+Tab).
      // Clicks elsewhere are handled by the document click listener below.
      if (!event.relatedTarget || item.contains(event.relatedTarget)) return;
      close(item);
    });

    p.panel.querySelectorAll('[data-sl-preview-target]').forEach(function (link) {
      var id = link.getAttribute('data-sl-preview-target');
      link.addEventListener('pointerenter', function () { showPreview(p.panel, id); });
      link.addEventListener('focus', function () { showPreview(p.panel, id); });
    });
  });

  if (scrim) {
    scrim.addEventListener('click', function () { close(current); });
  }

  document.addEventListener('click', function (event) {
    if (current && !current.contains(event.target)) close(current);
  });

  var onBreakpoint = function () { if (!desktop.matches && current) close(current); };
  if (desktop.addEventListener) {
    desktop.addEventListener('change', onBreakpoint);
  } else if (desktop.addListener) {
    desktop.addListener(onBreakpoint);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && current) close(current);
  });
})();
